module.exports = __webpack_public_path__ + "static/media/24-9.b35f622a.mp3";